import axios from 'axios'

class MasterDataFactory {
  async master_datas (data: any) {
    try {
      const url = '/master_datas'
      const response = await axios.get(url, {
        params: {
          school_years: data.school_years,
          bill_types: data.bill_types,
          bill_detail_types: data.bill_detail_types,
          classes: data.classes,
          months: data.months,
          school: data.school,
          math_operations: data.math_operations,
          order_statuses: data.order_statuses,
          convenience_fee: data.convenience_fee,
          merchants: data.merchants,
          custom_criterias: data.custom_criterias
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async setting_data (data: any) {
    try {
      const url = '/setting_data'
      const response = await axios.get(url, {
        params: {
          title: data.title
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async getConfigs () {
    try {
      const url = '/configs'
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async setConfigs (data: any) {
    try {
      const url = '/configs'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const masterDataFactory = new MasterDataFactory()
